(function () {

    angular.module('FotocApp')

        .service('$tutorialService', ['CONSTANTS','$timeout','$window', function (CONSTANTS, $timeout, $window) {

            var self = this;
        
            this.isOpen = false;
            this.animIn = false;

            var isUserAction = false;

            var TUTOS = {
                'init': ['menu', 'layouts', 'photos'],
                'size': ['size']
            }

            this.inSlide = 0;
            this.tuto = []
    
            this.changeStartTuto = function (){
                
                TUTOS.init[2] = 'user_actions'

                isUserAction = true;
            }

            function open(){
                self.inSlide = 0;
                self.isOpen = true;
                $timeout(function (){
                    self.animIn = true;
                }, 0);
            }

            this.showSlideOSFacebook = function (){
                this.tuto = ['ios_facebook'];
                open()
            };

            this.showSlideOSInstagram = function (){
                this.tuto = ['ios_instagram'];
                open()
            };

            this.showSlideAndroidFacebook = function (){
                this.tuto = ['android_facebook'];
                open()
            };

            this.showSlideAndroidInstagram = function (){
                this.tuto = ['android_instagram'];
                open()
            };

            this.close = function (){

                this.animIn = false;

                $timeout(function (){
                    self.isOpen = false;
                    self.inSlide = 0;
                }, 500);
                
            }

            this.show = function ($type){

                if(!$window.localStorage.getItem('fotoc.tutrial.'+$type)){
                    this.tuto = TUTOS[$type];
                    $window.localStorage.setItem('fotoc.tutrial.'+$type, 1)

                    this.inSlide = 0;
                    this.isOpen = true;
                    
                    $timeout(function (){
                        self.animIn = true;
                    }, 0);

               }else if(isUserAction && $type == 'init'){


                    this.tuto = ['user_actions'];
                
                    this.inSlide = 0;
                    this.isOpen = true;
                    
                    $timeout(function (){
                        self.animIn = true;
                    }, 0);


               }

            }
           


        }])
        

})();